import { render, staticRenderFns } from "./firewall.vue?vue&type=template&id=97388046&scoped=true&"
import script from "./firewall.vue?vue&type=script&lang=js&"
export * from "./firewall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97388046",
  null
  
)

export default component.exports